/* KMALL09 client search engine (260720)
 * Why: Shopify storefront search cannot do Korean infix matching ("라면" fails to
 * match "신라면"), has no autocomplete, and its facets are limited. This module
 * loads a compact product index (templates/collection.km-index.liquid via
 * /collections/all?view=km-index) and provides:
 *   1) header instant-suggest dropdown (infix + 초성 matching)
 *   1-b) barcode lookup (260826): a 6+ digit query matches variant barcodes
 *   2) full client-side search results page: live re-search, category/brand/
 *      temperature/price/sold-out facets, popularity/relevance/price/newest/
 *      discount sorting. Server-rendered results stay as a no-JS/SEO fallback.
 * All UI strings come from window.KMSearchCfg (locale keys) — no literals here.
 */
(function () {
  'use strict';
  var CFG = window.KMSearchCfg;
  if (!CFG || !window.fetch || !window.Promise) return;
  var S = CFG.s || {};
  /* Liquid `t` 필터가 번역을 HTML 이스케이프(&quot; 등)한 채 넘기므로 1회 디코드 —
     이후 esc()로 재이스케이프해 주입하니 안전 */
  (function () {
    var d = document.createElement('textarea');
    for (var k in S) {
      if (typeof S[k] === 'string' && S[k].indexOf('&') >= 0) { d.innerHTML = S[k]; S[k] = d.value; }
    }
  })();

  /* ---------------- utils ---------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  var NORM_RE = /[\s·.,\-_/()\[\]+&'"!%*#:;~]+/g;
  function norm(s) {
    if (!s) return '';
    s = String(s);
    if (s.normalize) s = s.normalize('NFC');
    return s.toLowerCase().replace(NORM_RE, '');
  }
  var CHO = 'ㄱㄲㄴㄷㄸㄹㅁㅂㅃㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎ';
  function cho(s) {
    if (!s) return '';
    var out = '';
    for (var i = 0; i < s.length; i++) {
      var c = s.charCodeAt(i);
      if (c >= 0xac00 && c <= 0xd7a3) out += CHO.charAt(Math.floor((c - 0xac00) / 588));
    }
    return out;
  }
  function isCho(s) { return /^[ㄱ-ㅎ]+$/.test(s); }
  /* 겹받침 분해: 초성을 연속으로 치면(ㅅ,ㄹ,ㅁ) IME가 뒤 둘을 겹자음(ㄹ+ㅁ=ㄻ)으로 합쳐 'ㅅㄻ'이 된다.
     상품 초성열은 단자음(신라면→ㅅㄹㅁ)이라 매칭이 깨지므로, 쿼리의 겹자음을 구성 자음으로 되돌린다.
     쌍자음(ㄲㄸㅃㅆㅉ)은 실제 초성(까/따/빠/싸/짜)이라 분해하지 않는다. */
  var CHO_SPLIT = { 'ㄳ': 'ㄱㅅ', 'ㄵ': 'ㄴㅈ', 'ㄶ': 'ㄴㅎ', 'ㄺ': 'ㄹㄱ', 'ㄻ': 'ㄹㅁ', 'ㄼ': 'ㄹㅂ', 'ㄽ': 'ㄹㅅ', 'ㄾ': 'ㄹㅌ', 'ㄿ': 'ㄹㅍ', 'ㅀ': 'ㄹㅎ', 'ㅄ': 'ㅂㅅ' };
  function splitCho(s) { var o = ''; for (var i = 0; i < s.length; i++) { var c = s.charAt(i); o += CHO_SPLIT[c] || c; } return o; }
  function fm(cents) {
    var v = cents / 100;
    var f = CFG.money || '${{amount}}';
    var out;
    if (f.indexOf('{{amount_no_decimals}}') >= 0) out = f.replace('{{amount_no_decimals}}', String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    else if (f.indexOf('{{amount_with_comma_separator}}') >= 0) out = f.replace('{{amount_with_comma_separator}}', v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
    else out = f.replace(/\{\{\s*amount\s*\}\}/, v.toFixed(2).replace(/\B(?=(\d{3})+(?!\.))/g, ','));
    return out.replace(/<[^>]*>/g, '');
  }
  function productUrl(it) {
    var root = CFG.root || '/';
    if (root.charAt(root.length - 1) === '/') root = root.slice(0, -1);
    return root + '/products/' + it.h;
  }
  function tmpl(str, map) {
    var out = String(str || '');
    for (var k in map) out = out.split(k).join(map[k]);
    return out;
  }
  function countText(n) { return n === 1 && S.count1 ? S.count1 : tmpl(S.count, { '987654321': String(n) }); }

  /* ---------------- index load ---------------- */
  var IDX = { items: null, loading: null };
  var EN = { map: null, loading: null }; /* 반대 로케일(주로 EN) 검색어 보강: id → 상품명 */
  var LS_KEY = 'km_idx_v6_' + (CFG.locale || 'ko'); /* v6: bc(바코드) 필드 추가 — 구캐시 즉시 무효화 */
  var LS_EN = 'km_terms_v1_' + (CFG.locale || 'ko');
  var TTL = 3600 * 1000; /* 1h — 상품·가격은 besir 동기화로 수시 변동 */

  function fetchPage(n) {
    return fetch(CFG.idx + '?view=km-index&sort_by=best-selling&page=' + n, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('km-index http ' + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t.trim()); });
  }
  function precompute(items) {
    var total = items.length || 1;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      it._r = i;
      it._t = norm(it.t);
      it._x = norm((it.b || '') + ' ' + (it.vn || '')) + '|' + norm((it.ty || '') + ' ' + (it.c1 || '') + ' ' + (it.c2 || '') + ' ' + (it.c3 || '')) + '|' + norm(it.h);
      it._c = cho(it.t);
      it._bl = it.bc ? String(it.bc).split(/\s+/).filter(Boolean) : null; /* 바코드 목록(260826) */
      it._e = (EN.map && EN.map[it.i]) ? norm(EN.map[it.i]) : ''; /* 영문(번역) 상품명 — 로드되면 foldEn이 채움 */
      it._pop = 12 * (1 - i / total);
      it._disc = (it.cp > it.p) ? (it.cp - it.p) / it.cp : 0;
    }
    return items;
  }

  /* ── 반대 로케일 검색어(주로 영어 번역) 보강 — 한글 스토어에서도 영어로 검색되게 ── */
  function altTermsBase() {
    var base = (CFG.idx || '/collections/all').replace(/^\/(en|zh-cn)(?=\/)/i, '');
    var isEn = (CFG.locale || '').toLowerCase().indexOf('en') === 0;
    return isEn ? base : '/en' + base; /* EN 스토어면 기본(KO) 보강, 그 외엔 EN 보강 */
  }
  function fetchTermsPage(n) {
    return fetch(altTermsBase() + '?view=km-terms&sort_by=best-selling&page=' + n, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('km-terms http ' + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t.trim()); });
  }
  function foldEn(map) {
    if (!IDX.items || !map) return;
    for (var i = 0; i < IDX.items.length; i++) { var t = map[IDX.items[i].i]; if (t) IDX.items[i]._e = norm(t); }
  }
  function ensureEnTerms() {
    if (EN.map) { foldEn(EN.map); return; }
    if (EN.loading) return;
    var cached = null;
    try { cached = JSON.parse(localStorage.getItem(LS_EN) || 'null'); } catch (e) { }
    if (cached && cached.map) { EN.map = cached.map; foldEn(EN.map); if ((Date.now() - (cached.ts || 0)) < TTL) return; }
    EN.loading = fetchTermsPage(1).then(function (p1) {
      var pages = Math.max(1, Math.min(60, p1.pages | 0));
      var reqs = [];
      for (var n = 2; n <= pages; n++) reqs.push(fetchTermsPage(n));
      return Promise.all(reqs).then(function (rest) {
        var map = {};
        (p1.items || []).forEach(function (x) { map[x.i] = x.t; });
        for (var i = 0; i < rest.length; i++) (rest[i].items || []).forEach(function (x) { map[x.i] = x.t; });
        EN.map = map;
        try { localStorage.setItem(LS_EN, JSON.stringify({ ts: Date.now(), map: map })); } catch (e) { }
        foldEn(map);
        try { window.dispatchEvent(new Event('km-en-ready')); } catch (e) { } /* 로드된 결과 재렌더 신호 */
        return map;
      });
    }).catch(function () { EN.loading = null; });
  }
  function fetchAll() {
    return fetchPage(1).then(function (p1) {
      var pages = Math.max(1, Math.min(60, p1.pages | 0));
      var reqs = [];
      for (var n = 2; n <= pages; n++) reqs.push(fetchPage(n));
      return Promise.all(reqs).then(function (rest) {
        var items = (p1.items || []).slice();
        for (var i = 0; i < rest.length; i++) items = items.concat(rest[i].items || []);
        try { localStorage.setItem(LS_KEY, JSON.stringify({ ts: Date.now(), items: items })); } catch (e) { }
        return items;
      });
    });
  }
  function loadIndex() {
    if (IDX.items) return Promise.resolve(IDX.items);
    if (IDX.loading) return IDX.loading;
    IDX.loading = new Promise(function (resolve, reject) {
      var cached = null;
      try { cached = JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { }
      var fresh = cached && cached.items && cached.items.length && (Date.now() - (cached.ts || 0)) < TTL;
      if (cached && cached.items && cached.items.length) {
        IDX.items = precompute(cached.items);
        resolve(IDX.items);
        ensureEnTerms();
        if (!fresh) { /* stale-while-revalidate: 다음 검색부터 새 인덱스 */
          fetchAll().then(function (items) { IDX.items = precompute(items); ensureEnTerms(); }).catch(function () { });
        }
        return;
      }
      fetchAll().then(function (items) { IDX.items = precompute(items); resolve(IDX.items); ensureEnTerms(); }).catch(reject);
    });
    return IDX.loading;
  }

  /* ---------------- query engine ---------------- */
  /* 바코드 매칭(260826) — 2=완전일치, 1=부분일치, 0=없음.
     직원이 실물 바코드를 찍어 상품을 찾을 수 있게 한다. 완전일치는 220점으로 제목 완전일치(120)보다
     높게 줘 스캔한 상품이 무조건 1위로 올라온다.
     🔴 부분일치는 8자리 이상일 때만 — 한국 상품 바코드는 880 으로 시작해서 짧은 숫자를 부분매칭하면
     수천 건이 걸린다. 완전일치는 길이 제한 없이 본다(8자리 EAN-8 등).
     레거시 핸들 상품(kmall-<바코드>)은 _x 의 handle 로도 잡히지만 20점뿐이라, 신규 SEO 핸들 상품과
     점수가 갈리지 않도록 여기서 같은 기준으로 처리한다. */
  function bcHit(list, q) {
    if (!list) return 0;
    var i;
    for (i = 0; i < list.length; i++) if (list[i] === q) return 2;
    if (q.length >= 8) for (i = 0; i < list.length; i++) if (list[i].indexOf(q) >= 0) return 1;
    return 0;
  }

  /* returns array of items, each with __sc relevance score; empty q → popularity order */
  function runQuery(items, q) {
    q = String(q || '').trim();
    if (!q) {
      var all = items.slice();
      for (var i = 0; i < all.length; i++) all[i].__sc = 0;
      return all;
    }
    var words = q.split(/\s+/);
    var toks = [];
    for (var w = 0; w < words.length; w++) {
      if (isCho(words[w])) toks.push({ c: true, v: splitCho(words[w]) });
      else { var nv = norm(words[w]); if (nv) toks.push({ c: false, v: nv, d: /^[0-9]{6,}$/.test(nv) }); }
    }
    if (!toks.length) return [];
    var out = [];
    for (var j = 0; j < items.length; j++) {
      var it = items[j], sc = 0, ok = true, bh;
      for (var k = 0; k < toks.length; k++) {
        var tk = toks[k];
        if (tk.c) {
          var cp = it._c.indexOf(tk.v);
          if (cp < 0) { ok = false; break; }
          sc += cp === 0 ? 40 : 22;
        } else {
          var p = it._t.indexOf(tk.v);
          if (p >= 0) sc += (it._t === tk.v ? 120 : (p === 0 ? 70 : 40));
          else if (it._e && it._e.indexOf(tk.v) >= 0) sc += (it._e.indexOf(tk.v) === 0 ? 55 : 36); /* 영문(번역) 상품명 매칭 */
          else if (tk.d && (bh = bcHit(it._bl, tk.v))) sc += (bh === 2 ? 220 : 60); /* 바코드 매칭(260826) */
          else if (it._x.indexOf(tk.v) >= 0) sc += 20;
          else { ok = false; break; }
        }
      }
      if (!ok) continue;
      sc += it._pop;
      if (!it.av) sc -= 30;
      /* 자주 산 상품 가산점(260807) — 내가 산 적 있는 상품을 검색 결과 위로.
         구매 횟수가 많을수록 더 올리되(회당 12점, 최대 60점) 관련도를 뒤엎지는
         않도록 상한을 둔다. 로그인 안 했거나 이력이 없으면 0점이라 영향 없음. */
      var bn = boughtCount(it.i);
      it.__bought = bn;
      if (bn) sc += Math.min(60, 12 * bn);
      it.__sc = sc;
      out.push(it);
    }
    return out;
  }

  /* 자주 산 상품(260807) — kmall-frequent.js 가 늦게(defer) 붙을 수 있으므로 호출 시점에 읽는다.
     비로그인·이력 없음이면 항상 0이라 기존 랭킹과 완전히 동일하게 동작한다. */
  function boughtCount(id) {
    var f = window.KM_FREQ;
    return (f && f.count) ? f.count(id) : 0;
  }

  var SORTS = {
    /* 인기순에서도 내가 산 상품을 앞에 — 판매가능 > 자주 산 > 원래 인기순 */
    pop: function (a, b) { return (b.av - a.av) || ((b.__bought || 0) - (a.__bought || 0)) || (a._r - b._r); },
    rel: function (a, b) { return (b.__sc - a.__sc) || (a._r - b._r); },
    pa: function (a, b) { return (b.av - a.av) || (a.p - b.p) || (a._r - b._r); },
    pd: function (a, b) { return (b.av - a.av) || (b.p - a.p) || (a._r - b._r); },
    nw: function (a, b) { return (b.av - a.av) || ((b.pt || b.ct) - (a.pt || a.ct)) || (a._r - b._r); }, /* 최신순 = 게시일 (파이프라인 상품은 생성≠게시) */
    dc: function (a, b) { return (b.av - a.av) || (b._disc - a._disc) || (a._r - b._r); }
  };

  function brandHidden(v) {
    if (!v) return true;
    return /pty|ltd|trading|international|intertrade|import|wholesale|_|kmall09/i.test(v) || /서점|북센|도서/.test(v);
  }

  /* ---------------- product card (mirrors snippets/kmall-product-card.liquid) ---------------- */
  function cardHTML(it) {
    var onSale = it.cp > it.p;
    var pct = onSale ? Math.ceil((it.cp - it.p) * 100 / it.cp) : 0;
    var offline = !!it.of; /* 매장 판매 전용 (kmall.pickup_only) — 배지·담기 게이트, 찜은 유지 */
    var badge = '', badgeCls = '';
    if (offline) { badge = S.badgeOffline || 'OFFLINE ONLY'; badgeCls = 'offline'; }
    else if (!it.av) { badge = S.soldOut; badgeCls = 'soldout'; }
    else if (onSale && pct >= 25) { badge = 'SALE'; badgeCls = 'sale'; }
    else if (it.fl === 'n') { badge = S.badgeNew; badgeCls = 'new'; }
    else if (it.fl === 'b') { badge = S.badgeBest; badgeCls = 'best'; }
    var fresh = it.tp === 'c' || it.tp === 'f';
    var b = it.b || '';
    var title = it.t || '';
    if (b && title.indexOf(b) === 0) title = title.slice(b.length).replace(/^\s+/, '');
    var url = productUrl(it);
    var img = it.img
      ? '<img src="' + esc(it.img) + '" alt="' + esc(it.t) + '" loading="lazy" decoding="async">'
      : '<span class="kmall-pc-ph">' + esc((it.t || '').split(/\s+/)[0]) + '</span>';
    /* 자주 산 상품(260807): Liquid 카드와 동일한 훅을 심어 kmall-frequent.js 가
       "N회 구매" 칩을 꽂고 우선 정렬할 수 있게 한다. */
    var h = '<div class="kmall-pc' + (offline ? ' offline' : (it.av ? '' : ' soldout')) + '"'
      + ' data-km-pid="' + esc(it.i) + '" data-km-name="' + esc((b ? b + ' ' : '') + (it.t || '')) + '">'
      + '<a href="' + esc(url) + '" class="kmall-pc-img">' + img
      + (badge ? '<span class="kmall-badge ' + badgeCls + '">' + esc(badge) + '</span>' : '')
      + '</a>'
      + '<button type="button" class="kmall-pcico kmall-heart" aria-label="' + esc(S.wishlist) + '" data-km-fave data-fid="' + esc(it.i) + '" data-ft="' + esc(it.t) + '" data-fp="' + esc(fm(it.p)) + '" data-fimg="' + esc(it.img || '') + '" data-fu="' + esc(url) + '"><svg class="kmall-ico"><use href="#km-heart"/></svg></button>'
      + '<div class="kmall-pc-body">'
      + '<a href="' + esc(url) + '" class="kmall-pc-nm">' + (b ? '<b>[' + esc(b) + ']</b> ' : '') + esc(title) + '</a>'
      + '<span class="kmall-pc-price"><span class="now">' + esc(fm(it.p)) + '</span>'
      + (onSale ? '<span class="was">' + esc(fm(it.cp)) + '</span><span class="off">&minus;' + pct + '%</span>' : '')
      + '</span>';
    if (it.rv > 0) h += '<span class="kmall-pc-rate"><svg class="kmall-star"><use href="#km-star"/></svg>' + (Math.round(it.rv * 10) / 10) + ' <span class="muted">(' + (it.rc || 0) + ')</span></span>';
    if (fresh) h += '<span class="kmall-fresh"><svg class="km-snow" aria-hidden="true"><use href="#km-snow"/></svg>K-Fresh</span>';
    if (offline) {
      h += '<div class="kmall-pc-atc offline"><span class="km-atc-out offline">' + esc(S.offlineOnly || 'In-store only') + '</span></div>';
    } else if (it.av) {
      h += '<div class="kmall-pc-atc" data-km-atc data-km-vid="' + esc(it.vid) + '" data-km-url="' + esc(url) + '">'
        + '<button type="button" class="km-atc-add" data-km-atc-add aria-label="' + esc(S.addToCart) + '"><svg class="kmall-ico"><use href="#km-bag"/></svg><span>' + esc(S.addToCart) + '</span></button>'
        + '<div class="km-atc-step" data-km-step-wrap hidden>'
        + '<button type="button" class="km-atc-btn km-atc-minus" data-km-step="-1" aria-label="' + esc(S.qtyDec) + '">&minus;</button>'
        + '<span class="km-atc-qty" data-km-qty aria-live="polite">0</span>'
        + '<button type="button" class="km-atc-btn km-atc-plus" data-km-step="1" aria-label="' + esc(S.qtyInc) + '">+</button>'
        + '</div></div>';
    } else {
      h += '<div class="kmall-pc-atc soldout"><span class="km-atc-out">' + esc(S.soldOut) + '</span></div>';
    }
    h += '</div></div>';
    return h;
  }
  function afterRender() {
    if (window.__kmAtcHydrate) window.__kmAtcHydrate();
    if (window.__kmFaveMark) window.__kmFaveMark();
  }

  /* ---------------- header instant suggest ---------------- */
  function attachSuggest(form) {
    if (!form || form.__kmSgg) return;
    var inp = form.querySelector('input[name="q"]');
    if (!inp) return;
    form.__kmSgg = 1;
    var box = document.createElement('div');
    box.className = 'kmall-sgg';
    box.hidden = true;
    form.appendChild(box);
    var act = -1, rowEls = [];
    function hide() { box.hidden = true; act = -1; }
    function setActive(n) {
      act = n;
      for (var i = 0; i < rowEls.length; i++) rowEls[i].classList.toggle('on', i === act);
    }
    function render() {
      var q = inp.value.trim();
      if (!q) { hide(); return; }
      loadIndex().then(function (items) {
        if (inp.value.trim() !== q) return; /* stale */
        var res = runQuery(items, q).sort(SORTS.rel);
        var top = res.slice(0, 8);
        var h = '';
        for (var i = 0; i < top.length; i++) {
          var it = top[i];
          var b = it.b || '';
          var title = it.t || '';
          if (b && title.indexOf(b) === 0) title = title.slice(b.length).replace(/^\s+/, '');
          h += '<a class="kmall-sgg-it' + (it.av ? '' : ' so') + '" href="' + esc(productUrl(it)) + '">'
            + '<span class="im">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : '') + '</span>'
            + '<span class="tx"><span class="nm">' + (b ? '<b>[' + esc(b) + ']</b> ' : '') + esc(title) + '</span>'
            + '<span class="pr">' + esc(fm(it.p)) + (it.cp > it.p ? ' <s>' + esc(fm(it.cp)) + '</s>' : '') + (it.av ? '' : ' · ' + esc(S.soldOut)) + '</span></span>'
            + '</a>';
        }
        if (!top.length) h += '<div class="kmall-sgg-none">' + esc(S.noSuggest) + '</div>';
        h += '<button type="submit" class="kmall-sgg-all">' + esc(S.viewAll) + (res.length ? ' · ' + esc(countText(res.length)) : '') + '</button>';
        box.innerHTML = h;
        rowEls = [].slice.call(box.querySelectorAll('.kmall-sgg-it'));
        act = -1;
        box.hidden = false;
      }).catch(hide);
    }
    var t;
    inp.addEventListener('input', function () { clearTimeout(t); t = setTimeout(render, 120); });
    inp.addEventListener('focus', function () { loadIndex().catch(function () { }); if (inp.value.trim()) render(); });
    inp.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(act + 1, rowEls.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(act - 1, -1)); }
      else if (e.key === 'Escape') { hide(); }
      else if (e.key === 'Enter' && act >= 0 && rowEls[act]) { e.preventDefault(); window.location.href = rowEls[act].getAttribute('href'); }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
  }

  /* ---------------- search results page (CSR takeover) ---------------- */
  function initSearchPage() {
    var csr = document.querySelector('[data-km-csr]');
    if (!csr) return;
    var ssr = document.querySelector('[data-km-ssr]');
    var bigForm = document.querySelector('[data-km-bigsearch]');
    var bigInput = bigForm ? bigForm.querySelector('input[name="q"]') : null;
    var PAGE = 100;

    /* state (restored from URL) */
    var usp;
    try { usp = new URLSearchParams(window.location.search); } catch (e) { usp = null; }
    function getSet(key) {
      var v = usp && usp.get(key);
      var o = {};
      if (v) v.split('|').forEach(function (x) { x = decodeURIComponent(x); if (x) o[x] = 1; });
      return o;
    }
    var ST = {
      q: (usp && usp.get('q')) || '',   /* 원래(헤더) 검색어 — 결과 내 재검색의 기준, 세션 중 불변 */
      rf: (usp && usp.get('krf')) || '', /* 결과 내 재검색어 — 페이지 검색창이 편집(기준어에 AND로 좁힘) */
      c1: getSet('kc1'), c2: getSet('kc2'), br: getSet('kbr'), tp: getSet('ktp'),
      pmin: usp && usp.get('kmin') ? parseFloat(usp.get('kmin')) : null,
      pmax: usp && usp.get('kmax') ? parseFloat(usp.get('kmax')) : null,
      so: !(usp && usp.get('kso') === '0'),
      sort: (usp && usp.get('ksort')) || '',
      shown: PAGE
    };
    /* seed from SSR facet params so 기존 공유 URL도 이어받는다 */
    if (usp) {
      usp.getAll('filter.p.vendor').forEach(function (v) { if (v) ST.br[v] = 1; });
      var g = usp.get('filter.v.price.gte'); if (g) ST.pmin = parseFloat(g);
      var l = usp.get('filter.v.price.lte'); if (l) ST.pmax = parseFloat(l);
    }
    var ALL = null, openFacet = '';

    function setOf(o) { return Object.keys(o); }
    function hasAny(o) { for (var k in o) return true; return false; }
    /* 유효 검색어 = 기준어 + 재검색어를 공백으로 이어붙임 → 엔진의 다중키워드 AND로 '결과 내 좁히기' 구현 */
    function effQ() { var a = []; if (ST.q) a.push(ST.q); if (ST.rf) a.push(ST.rf); return a.join(' '); }
    function curSort() { return ST.sort || (effQ() ? 'rel' : 'pop'); }

    function passes(it, skip) {
      if (skip !== 'c1' && hasAny(ST.c1) && !ST.c1[it.c1 || '']) return false;
      if (skip !== 'c2' && hasAny(ST.c2) && !ST.c2[it.c2 || '']) return false;
      if (skip !== 'br' && hasAny(ST.br) && !ST.br[it.vn || '']) return false;
      if (skip !== 'tp' && hasAny(ST.tp) && !ST.tp[it.tp || 'd']) return false;
      if (skip !== 'pr') {
        if (ST.pmin != null && it.p < ST.pmin * 100) return false;
        if (ST.pmax != null && it.p > ST.pmax * 100) return false;
      }
      if (skip !== 'so' && !ST.so && !it.av) return false;
      return true;
    }
    function tally(matched, skip, field) {
      var m = {};
      for (var i = 0; i < matched.length; i++) {
        var it = matched[i];
        if (!passes(it, skip)) continue;
        var v = field(it);
        if (!v) continue;
        m[v] = (m[v] || 0) + 1;
      }
      return m;
    }

    function syncUrl() {
      if (!usp || !window.history || !window.history.replaceState) return;
      try {
        var u = new URLSearchParams(window.location.search);
        ['kc1', 'kc2', 'kbr', 'ktp', 'kmin', 'kmax', 'kso', 'ksort', 'krf'].forEach(function (k) { u.delete(k); });
        if (ST.q) u.set('q', ST.q); else u.delete('q');
        if (ST.rf) u.set('krf', ST.rf);
        u.set('type', 'product');
        function put(k, o) { var a = setOf(o); if (a.length) u.set(k, a.map(encodeURIComponent).join('|')); }
        put('kc1', ST.c1); put('kc2', ST.c2); put('kbr', ST.br); put('ktp', ST.tp);
        if (ST.pmin != null) u.set('kmin', String(ST.pmin));
        if (ST.pmax != null) u.set('kmax', String(ST.pmax));
        if (!ST.so) u.set('kso', '0');
        if (ST.sort) u.set('ksort', ST.sort);
        window.history.replaceState(null, '', window.location.pathname + '?' + u.toString());
      } catch (e) { }
    }

    function facetHTML(key, label, counts, activeSet, opts) {
      opts = opts || {};
      var keys = Object.keys(counts);
      /* active values always listed, even count 0 */
      setOf(activeSet).forEach(function (v) { if (!(v in counts)) counts[v] = 0; });
      keys = Object.keys(counts).sort(function (a, b) { return (counts[b] - counts[a]) || a.localeCompare(b, 'ko'); });
      if (opts.hide) keys = keys.filter(function (v) { return activeSet[v] || !opts.hide(v); });
      if (!keys.length) return '';
      var nAct = setOf(activeSet).length;
      var h = '<details class="kmall-facet" data-kf-facet="' + key + '"' + (openFacet === key ? ' open' : '') + '>'
        + '<summary class="kmall-facet-btn">' + esc(label) + (nAct ? ' <span class="fc">' + nAct + '</span>' : '') + ' <svg class="fch" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"/></svg></summary>'
        + '<div class="kmall-facet-panel">';
      if (opts.search) h += '<input type="text" class="kmall-facet-search" placeholder="' + esc(tmpl(S.fSearchPh, { '__KML__': label })) + '" aria-label="' + esc(label) + '">';
      h += '<div class="kmall-facet-list">';
      for (var i = 0; i < keys.length; i++) {
        var v = keys[i];
        var lb = opts.label ? opts.label(v) : v;
        h += '<a class="kmall-facet-opt' + (activeSet[v] ? ' on' : '') + '" href="#" data-kf="' + key + '" data-kv="' + esc(v) + '"><span class="lb">' + esc(lb) + '</span><span class="vc">' + counts[v] + '</span></a>';
      }
      h += '</div></div></details>';
      return h;
    }
    function tempLabel(v) { return v === 'f' ? S.tempF : v === 'c' ? S.tempC : S.tempD; }

    function priceFacetHTML() {
      var nAct = (ST.pmin != null ? 1 : 0) + (ST.pmax != null ? 1 : 0);
      return '<details class="kmall-facet" data-kf-facet="pr"' + (openFacet === 'pr' ? ' open' : '') + '>'
        + '<summary class="kmall-facet-btn">' + esc(S.fPrice) + (nAct ? ' <span class="fc">' + nAct + '</span>' : '') + ' <svg class="fch" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"/></svg></summary>'
        + '<div class="kmall-facet-panel"><div class="kmall-price-form">'
        + '<div class="kmall-price-row">'
        + '<input type="number" inputmode="decimal" min="0" step="0.01" data-kf-min value="' + (ST.pmin != null ? ST.pmin : '') + '" placeholder="0" aria-label="' + esc(S.fMin) + '">'
        + '<span class="dash">&ndash;</span>'
        + '<input type="number" inputmode="decimal" min="0" step="0.01" data-kf-max value="' + (ST.pmax != null ? ST.pmax : '') + '" placeholder="&nbsp;" aria-label="' + esc(S.fMax) + '">'
        + '</div><button type="button" data-kf-price-apply>' + esc(S.apply) + '</button>'
        + '</div></div></details>';
    }

    function build() {
      csr.innerHTML =
        '<div data-km-cfacets></div>'
        + '<div class="kmall-sortbar"><div class="res" data-km-cres aria-live="polite"></div><div class="right">'
        + '<a class="kmall-instock" role="switch" href="#" data-km-cso><span class="km-sw" aria-hidden="true"></span>' + esc(S.inclSoldOut) + '</a>'
        + '<div class="kmall-select"><select data-km-csort aria-label="' + esc(S.sortBy) + '"></select><svg viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"/></svg></div>'
        + '</div></div>'
        + '<div class="kmall-grid" data-km-cgrid></div>'
        + '<div class="kmall-empty" data-km-cempty hidden>' + esc(S.noResults) + '</div>'
        + '<div class="kmall-csr-more"><button type="button" data-km-more hidden>' + esc(S.loadMore) + '</button></div>';
    }

    function render() {
      var matchedQ = runQuery(ALL, effQ());
      /* facet counts: disjunctive (자기 차원 제외 나머지 필터 적용) */
      var fa = document.querySelector('[data-km-cfacets]');
      var h = '<div class="kmall-facets">';
      h += facetHTML('c1', S.fCategory, tally(matchedQ, 'c1', function (it) { return it.c1; }), ST.c1, { search: true });
      if (hasAny(ST.c1)) {
        h += facetHTML('c2', S.fSubcategory, tally(matchedQ, 'c2', function (it) { return ST.c1[it.c1 || ''] ? it.c2 : ''; }), ST.c2, {});
      }
      h += facetHTML('br', S.fBrand, tally(matchedQ, 'br', function (it) { return it.vn; }), ST.br, { search: true, hide: brandHidden });
      h += facetHTML('tp', S.fTemp, tally(matchedQ, 'tp', function (it) { return it.tp || 'd'; }), ST.tp, { label: tempLabel });
      h += priceFacetHTML();
      var nAct = setOf(ST.c1).length + setOf(ST.c2).length + setOf(ST.br).length + setOf(ST.tp).length + (ST.pmin != null || ST.pmax != null ? 1 : 0);
      if (nAct) h += '<a class="kmall-facet-clear" href="#" data-kf-clear>' + esc(S.clearAll) + '</a>';
      h += '</div>';
      fa.innerHTML = h;

      /* results */
      var res = [];
      for (var i = 0; i < matchedQ.length; i++) if (passes(matchedQ[i], '')) res.push(matchedQ[i]);
      res.sort(SORTS[curSort()] || SORTS.pop);

      var resEl = document.querySelector('[data-km-cres]');
      var head = ST.q || ST.rf; /* 기준어가 있으면 그것을, 없으면 재검색어를 '검색 결과' 문구로 */
      var rb = head ? esc(tmpl(S.resultsFor, { '__KMT__': head })) : '';
      /* 기준어가 있는 상태에서 재검색어가 붙으면 제거 가능한 칩으로 표시(결과 내 재검색 맥락) */
      if (ST.q && ST.rf) rb += ' <a class="km-refine-tag" href="#" data-kf-refine-clear title="' + esc(S.clearRefine) + '">' + esc(ST.rf) + ' <span class="x" aria-hidden="true">&times;</span></a>';
      rb += (rb ? ' · ' : '') + '<b>' + esc(countText(res.length)) + '</b>';
      resEl.innerHTML = rb;

      var so = document.querySelector('[data-km-cso]');
      so.classList.toggle('on', ST.so);
      so.setAttribute('aria-checked', ST.so ? 'true' : 'false');

      var sel = document.querySelector('[data-km-csort]');
      var opts = [];
      if (effQ()) opts.push(['rel', S.sRelevance]);
      opts.push(['pop', S.sPopular], ['pa', S.sPriceAsc], ['pd', S.sPriceDesc], ['nw', S.sNewest], ['dc', S.sDiscount]);
      var cur = curSort();
      sel.innerHTML = opts.map(function (o) { return '<option value="' + o[0] + '"' + (o[0] === cur ? ' selected' : '') + '>' + esc(o[1]) + '</option>'; }).join('');

      var grid = document.querySelector('[data-km-cgrid]');
      var slice = res.slice(0, ST.shown);
      var gh = '';
      for (var g = 0; g < slice.length; g++) gh += cardHTML(slice[g]);
      grid.innerHTML = gh;
      document.querySelector('[data-km-cempty]').hidden = res.length > 0;
      var more = document.querySelector('[data-km-more]');
      more.hidden = res.length <= ST.shown;
      if (!more.hidden) more.textContent = S.loadMore + ' (' + slice.length + '/' + res.length + ')';
      afterRender();
      syncUrl();
    }

    function change(reset) {
      if (reset !== false) ST.shown = PAGE;
      render();
    }

    /* delegated events */
    csr.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-kf]');
      if (opt) {
        e.preventDefault();
        var key = opt.getAttribute('data-kf'), v = opt.getAttribute('data-kv');
        var map = { c1: ST.c1, c2: ST.c2, br: ST.br, tp: ST.tp }[key];
        if (map) {
          if (map[v]) delete map[v]; else map[v] = 1;
          if (key === 'c1') ST.c2 = {}; /* 대분류 바뀌면 세부분류 초기화 */
          openFacet = key;
          change();
        }
        return;
      }
      if (e.target.closest('[data-kf-clear]')) {
        e.preventDefault();
        ST.c1 = {}; ST.c2 = {}; ST.br = {}; ST.tp = {}; ST.pmin = null; ST.pmax = null;
        openFacet = '';
        change();
        return;
      }
      if (e.target.closest('[data-kf-refine-clear]')) {
        e.preventDefault();
        ST.rf = ''; if (bigInput) bigInput.value = '';
        change();
        return;
      }
      if (e.target.closest('[data-kf-price-apply]')) {
        e.preventDefault();
        var mn = csr.querySelector('[data-kf-min]'), mx = csr.querySelector('[data-kf-max]');
        ST.pmin = mn && mn.value !== '' ? parseFloat(mn.value) : null;
        ST.pmax = mx && mx.value !== '' ? parseFloat(mx.value) : null;
        openFacet = '';
        change();
        return;
      }
      var soBtn = e.target.closest('[data-km-cso]');
      if (soBtn) { e.preventDefault(); ST.so = !ST.so; change(); return; }
      var moreBtn = e.target.closest('[data-km-more]');
      if (moreBtn) { ST.shown += PAGE; change(false); return; }
    });
    csr.addEventListener('change', function (e) {
      if (e.target.closest('[data-km-csort]')) { ST.sort = e.target.value; change(); }
    });
    csr.addEventListener('input', function (e) {
      var s = e.target.closest('.kmall-facet-search');
      if (!s) return;
      var qq = s.value.trim().toLowerCase();
      var panel = s.closest('.kmall-facet-panel');
      [].forEach.call(panel.querySelectorAll('.kmall-facet-opt'), function (a) {
        var lb = a.querySelector('.lb');
        a.style.display = (!qq || (lb && lb.textContent.toLowerCase().indexOf(qq) >= 0)) ? '' : 'none';
      });
    });
    csr.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.closest('.kmall-facet-search')) e.preventDefault();
      if (e.key === 'Enter' && (e.target.closest('[data-kf-min]') || e.target.closest('[data-kf-max]'))) {
        e.preventDefault();
        var b = csr.querySelector('[data-kf-price-apply]');
        if (b) b.click();
      }
    });
    /* 패널 하나만 열림 + 바깥 클릭 시 닫기 (동적 DOM이라 자체 위임) */
    csr.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.matches || !d.matches('.kmall-facet')) return;
      if (d.open) {
        openFacet = d.getAttribute('data-kf-facet') || '';
        [].forEach.call(csr.querySelectorAll('.kmall-facet[open]'), function (o) { if (o !== d) o.removeAttribute('open'); });
      } else if (openFacet === d.getAttribute('data-kf-facet')) openFacet = '';
    }, true);
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.kmall-facet')) {
        openFacet = '';
        [].forEach.call(csr.querySelectorAll('.kmall-facet[open]'), function (o) { o.removeAttribute('open'); });
      }
    });

    /* 페이지 검색창 = '결과 내 재검색'(refine). 기준어(ST.q)는 그대로 두고 입력을 ST.rf로 좁힌다.
       기준어가 없으면(빈 q로 들어온 경우) ST.rf가 곧 메인 검색어가 되어 일반 검색처럼 동작. */
    if (bigForm && bigInput) {
      var t;
      bigInput.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { ST.rf = bigInput.value.trim(); ST.sort = ''; change(); }, 150);
      });
      bigForm.addEventListener('submit', function (e) {
        if (!ALL) return; /* index 미로드 → 서버 검색으로 폴백 */
        e.preventDefault();
        ST.rf = bigInput.value.trim(); ST.sort = '';
        change();
      });
    }

    loadIndex().then(function (items) {
      ALL = items;
      if (ssr) ssr.hidden = true;
      csr.hidden = false;
      /* CSR 인수: 페이지 검색창을 재검색 상태로 세팅. 기준어가 있으면 placeholder를 '「기준어」 결과 내 재검색'으로,
         값은 현재 재검색어로 채운다(SSR 폴백은 기준어를 그대로 유지하므로 no-JS에서도 정상 검색). */
      if (bigInput) {
        bigInput.value = ST.rf || '';
        if (ST.q) bigInput.setAttribute('placeholder', tmpl(S.refineWithin, { '__KMT__': ST.q }));
      }
      build();
      render();
      /* 영문 검색어 보강이 뒤늦게 도착하면 현재 결과를 다시 그려 영어 매칭을 반영 */
      window.addEventListener('km-en-ready', function () { if (ALL) render(); });
    }).catch(function () { /* 인덱스 실패 → 서버 렌더 결과 유지 */ });
  }

  /* ---------------- collection page (CSR blended sort, 260810) ----------------
   * 카테고리 페이지 기본 정렬 정책(260810 대표 승인): 품절은 무조건 뒤로, 나머지는
   * 판매량 순위 + 신상 가점의 블렌드 점수순. 신상 가점 = 0.35 × 2^(-등록경과일/14)
   * — 등록 직후엔 카테고리 상위 ~30% 지점에서 시작해 반감기 14일로 감쇠, 4주 뒤
   * 사실상 소멸(그 뒤는 실판매로 승부). 서버 렌더(Shopify 판매량순)는 SEO·no-JS
   * 폴백으로 유지하고, 필터·명시적 sort_by·2페이지 이상 등 "기본 화면"이 아니면
   * CSR을 포기해 기존 서버 필터·페이징과 충돌하지 않는다. */
  var NEW_BOOST = 0.35, NEW_HALFLIFE_D = 14;
  function initCollectionPage() {
    var csr = document.querySelector('[data-km-coll-csr]');
    if (!csr) return;
    var ssr = document.querySelector('[data-km-coll-ssr]');
    var usp;
    try { usp = new URLSearchParams(window.location.search); } catch (e) { return; }
    /* 기본 화면 판정: 허용 파라미터 외(브랜드/가격 필터, sort_by, 2페이지↑)가 있으면 SSR 유지 */
    var clean = true, avVals = [];
    usp.forEach(function (v, k) {
      if (k === 'filter.v.availability') { avVals.push(v); return; }
      if (k === 'preview_theme_id' || k === 'view' || k === 'utm_source' || k === 'utm_medium' || k === 'utm_campaign' || k === 'utm_content' || k === 'utm_term' || k === 'fbclid' || k === 'gclid') return;
      if (k === 'page' && v === '1') return;
      clean = false;
    });
    if (!clean) return;
    if (avVals.length && avVals.slice().sort().join(',') !== '0,1') return; /* 재고 필터를 손댄 URL은 서버 소관 */
    var title = csr.getAttribute('data-km-title') || '';
    var handle = csr.getAttribute('data-km-handle') || '';
    var scount = parseInt(csr.getAttribute('data-km-count') || '0', 10);
    var PAGE = 100;
    var ST = { so: true, sort: '', shown: PAGE };
    var RES = null;

    loadIndex().then(function (items) {
      var res = [];
      if (handle === 'all') res = items.slice();
      else if (title) {
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (it.c1 === title || it.c2 === title || it.c3 === title) res.push(it);
        }
      }
      if (!res.length) return; /* 카테고리 매칭 실패(큐레이션 컬렉션 등) → SSR 유지 */
      if (scount > 0) {
        var ratio = res.length / scount;
        if (ratio < 0.8 || ratio > 1.25) return; /* 안전밸브: 서버 개수와 크게 어긋나면 SSR 유지 */
      }
      /* 블렌드 점수 — res는 km-index(판매량순) 순서라 i가 곧 카테고리 내 판매량 순위.
         신상 가점은 "카테고리 내 최신 게시 상위 min(15, 8%)"에만 준다(진짜 신상 슬롯).
         카탈로그 대량 확장기엔 게시 21일 내 상품이 절반을 넘어(실측 53%, 260810),
         전부 부스트하면 판매량 정렬이 통째로 뒤집히기 때문. */
      var nowS = Date.now() / 1000, n = res.length;
      var K = Math.min(15, Math.ceil(n * 0.08));
      var byFresh = res.slice().sort(function (a, b) { return (b.pt || b.ct || 0) - (a.pt || a.ct || 0); });
      var freshBoost = {};
      for (var f = 0; f < K && f < byFresh.length; f++) {
        var aD = Math.max(0, (nowS - (byFresh[f].pt || byFresh[f].ct || 0)) / 86400);
        if (aD <= 21) freshBoost[byFresh[f].i] = Math.pow(2, -aD / NEW_HALFLIFE_D);
      }
      for (var j = 0; j < n; j++) {
        var x = res[j];
        x.__blend = (1 - j / n) + NEW_BOOST * (freshBoost[x.i] || 0);
        x.__bought = boughtCount(x.i);
      }
      RES = res;
      if (ssr) ssr.hidden = true;
      csr.hidden = false;
      build();
      render();
    }).catch(function () { /* 인덱스 실패 → 서버 렌더 유지 */ });

    var CSORTS = {
      cb: function (a, b) { return (b.av - a.av) || ((b.__bought || 0) - (a.__bought || 0)) || (b.__blend - a.__blend) || (a._r - b._r); },
      pa: SORTS.pa, pd: SORTS.pd, nw: SORTS.nw, dc: SORTS.dc
    };

    function build() {
      csr.innerHTML =
        '<div class="kmall-sortbar"><div class="res" data-km-collres aria-live="polite"></div><div class="right">'
        + '<a class="kmall-instock" role="switch" href="#" data-km-collso><span class="km-sw" aria-hidden="true"></span>' + esc(S.inclSoldOut) + '</a>'
        + '<div class="kmall-select"><select data-km-collsort aria-label="' + esc(S.sortBy) + '"></select><svg viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"/></svg></div>'
        + '</div></div>'
        + '<div class="kmall-grid kmall-grid-full" data-km-collgrid></div>'
        + '<div class="kmall-csr-more"><button type="button" data-km-collmore hidden>' + esc(S.loadMore) + '</button></div>';
    }

    function render() {
      var res = [];
      for (var i = 0; i < RES.length; i++) if (ST.so || RES[i].av) res.push(RES[i]);
      res.sort(CSORTS[ST.sort] || CSORTS.cb);

      document.querySelector('[data-km-collres]').innerHTML = '<b>' + esc(countText(res.length)) + '</b>';
      var so = document.querySelector('[data-km-collso]');
      so.classList.toggle('on', ST.so);
      so.setAttribute('aria-checked', ST.so ? 'true' : 'false');
      var sel = document.querySelector('[data-km-collsort]');
      var opts = [['cb', S.sPopular], ['pa', S.sPriceAsc], ['pd', S.sPriceDesc], ['nw', S.sNewest], ['dc', S.sDiscount]];
      var cur = ST.sort || 'cb';
      sel.innerHTML = opts.map(function (o) { return '<option value="' + o[0] + '"' + (o[0] === cur ? ' selected' : '') + '>' + esc(o[1]) + '</option>'; }).join('');

      var slice = res.slice(0, ST.shown), gh = '';
      for (var g = 0; g < slice.length; g++) gh += cardHTML(slice[g]);
      document.querySelector('[data-km-collgrid]').innerHTML = gh;
      var more = document.querySelector('[data-km-collmore]');
      more.hidden = res.length <= ST.shown;
      if (!more.hidden) more.textContent = S.loadMore + ' (' + slice.length + '/' + res.length + ')';
      afterRender();
    }

    csr.addEventListener('click', function (e) {
      var soBtn = e.target.closest('[data-km-collso]');
      if (soBtn) { e.preventDefault(); ST.so = !ST.so; ST.shown = PAGE; render(); return; }
      var moreBtn = e.target.closest('[data-km-collmore]');
      if (moreBtn) { ST.shown += PAGE; render(); return; }
    });
    csr.addEventListener('change', function (e) {
      if (e.target.closest('[data-km-collsort]')) { ST.sort = e.target.value; ST.shown = PAGE; render(); }
    });
  }

  /* ---------------- boot ---------------- */
  function boot() {
    [].forEach.call(document.querySelectorAll('form.kmall-search'), attachSuggest);
    initSearchPage();
    initCollectionPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
